@if (displayBreadCrumbs) {
  <div class="container">
    <div class="breadcrumbs">
      @if (!breadcrumbsLoading) {
        <ol class="bare-list breadcrumbs">
          @for (breadcrumb of breadcrumbs; track breadcrumb.url) {
            <li aria-current="page" class="breadcrumbs__item"
                property="itemListElement" typeof="ListItem">
              @if (!breadcrumb.breadcrumbDisabled) {
                <a class="breadcrumbs__link" [routerLink]="breadcrumb.url"
                   property="item" typeof="WebPage">
                  <span property="name">
                    {{ breadcrumbLabelDecoded(breadcrumb.label) }}
                  </span>
                </a>
              } @else {
                <span class="breadcrumbs__link">
                  <span property="name">
                    {{ breadcrumbLabelDecoded(breadcrumb.label) }}
                  </span>
                </span>
              }
            </li>
          }
        </ol>
      } @else {
        <ol class="bare-list breadcrumbs">
          <li class="breadcrumbs__item">
            <a class="breadcrumbs__link" [routerLink]="breadcrumbs[0].url">
              {{ 'app-breadcrumb.home' | translate }}
            </a>
          </li>
          <li class="loading-breadcrumbs">
            <span class="stripe"></span>
          </li>
        </ol>
      }
    </div>
  </div>
}
